import { Directive, HostListener } from '@angular/core';

@Directive()

export class PainelArrastavelBase {
  posicaoArrasteZerada = { x: 0, y: 0 };
  posicaoAtualArraste = { x: 0, y: 0 };
  espacoHorizontal = 0;
  espacoVertical = 0;
  posicaoAnteriorArraste = { x: 0, y: 0 };
  ligado = false;

  funcaoFechar = () => {
    this.ligado = false;
    this.posicaoAtualArraste = this.posicaoArrasteZerada
  }

  @HostListener("window:resize", [])
  funcaoCapturarTamanhoJanela = () => {
    this.espacoHorizontal = window.innerWidth;
    this.espacoVertical = window.innerHeight;
  }

  funcaoIniciarArraste = (evento) => {
    this.posicaoAnteriorArraste.x = this.posicaoAtualArraste.x;
    this.posicaoAnteriorArraste.y = this.posicaoAtualArraste.y;
  }

  funcaoArrastar = (evento) => {
    var x = evento.distance.x + this.posicaoAnteriorArraste.x;
    var y = evento.distance.y + this.posicaoAnteriorArraste.y;

    if (x > this.espacoHorizontal - 100) {
      x = this.espacoHorizontal - 100;
    }
    else if (x < 0) {
      x = 0;
    }

    if (y > this.espacoVertical - 100) {
      y = this.espacoVertical - 100;
    }
    else if (y < 0) {
      y = 0;
    }

    this.posicaoAtualArraste = { x: x, y: y };
  }
}
